import axios from 'axios';

const apiBase = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '') || 'http://localhost:8000';
const baseURL = `${apiBase}/api/v1`;

const apiClient = axios.create({
  baseURL,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if ((config.method || 'get').toLowerCase() === 'get') {
    config.params = { ...config.params, _: Date.now() };
    config.headers['Cache-Control'] = 'no-cache';
    config.headers.Pragma = 'no-cache';
  }
  return config;
});

// 401 → oturum süresi dolmuş, kullanıcıya bilgi ver
apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && typeof window !== 'undefined') {
      const path = window.location.pathname || '';
      if (path.startsWith('/admin') && !path.includes('/admin/login')) {
        localStorage.removeItem('adminToken');
        window.location.href = '/admin/login?expired=1';
      }
    }
    return Promise.reject(err);
  }
);

export default apiClient;
